import { ApiService } from '../apiService'
import type { UserProfileDto } from '../../types/profile'

/**
 * API endpoints for file uploads
 */
export const uploadsApi = {
  /**
   * Upload user avatar/profile picture
   * @param file - Image file (max 2MB, JPEG/PNG/WebP/GIF)
   * @returns Updated user profile with new avatar URL
   */
  uploadAvatar: async (file: File): Promise<UserProfileDto> => {
    const formData = new FormData()
    formData.append('file', file)
    return ApiService.upload<UserProfileDto>('/api/me/profile/avatar', formData)
  },

  /**
   * Upload user cover photo/banner
   * @param file - Image file (max 10MB, JPEG/PNG/WebP/GIF)
   * @returns Updated user profile with new cover photo URL
   */
  uploadCoverPhoto: async (file: File): Promise<UserProfileDto> => {
    const formData = new FormData()
    formData.append('file', file)
    return ApiService.upload<UserProfileDto>('/api/me/profile/cover', formData)
  },

  /**
   * General image upload for HTML editor or other purposes
   * @param file - Image file (max 10MB)
   * @param category - Optional category for organization
   * @returns Plain text URL string
   */
  uploadImage: async (file: File, category?: string): Promise<string> => {
    const formData = new FormData()
    formData.append('Image', file)
    if (category) {
      formData.append('category', category)
    }
    // This endpoint returns plain text, not JSON
    return ApiService.upload<string>('/api/ImageProcessing/upload', formData)
  },
}
